import { isPosFn } from 'src/config'
import { AVAILABILITY_BADGE_DISPLAY_TYPES } from 'src/models/inventory-strategy/InventoryStrategy'
import availabilitiesAndConstraintsService from 'src/services/inventory/sales-restrictions/AvailabilitiesAndConstraintsService'
import availableStockService from 'src/services/inventory/sales-restrictions/AvailableStockService'
import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'
import isOutOfStockService from 'src/services/inventory/sales-restrictions/IsOutOfStockService'

class IsAvailabilityBadgeVisibleService {
  static #instance = null

  static #availabilitiesAndConstraintsService = null
  static #availableStockService = null
  static #isOutOfStockService = null

  constructor ({
    availabilitiesAndConstraintsService,
    availableStockService,
    isOutOfStockService
  }) {
    if (!IsAvailabilityBadgeVisibleService.#instance) {
      IsAvailabilityBadgeVisibleService.#availabilitiesAndConstraintsService = availabilitiesAndConstraintsService
      IsAvailabilityBadgeVisibleService.#availableStockService = availableStockService
      IsAvailabilityBadgeVisibleService.#isOutOfStockService = isOutOfStockService

      IsAvailabilityBadgeVisibleService.#instance = this
    }
    return IsAvailabilityBadgeVisibleService.#instance
  }

  isAvailabilityBadgeVisible (model, options) {
    if (!isPosFn()) return false

    if (model.areSalesRequirementsUnmet || model.salesDisabled) return false

    const inventoryStrategy = getInventoryStrategy()

    if (_.isNil(inventoryStrategy?.inventoryRestrictionType)) return false

    if (_.isNil(inventoryStrategy?.availabilityBadgeDisplayType)) return false

    if (!IsAvailabilityBadgeVisibleService.#availabilitiesAndConstraintsService.isModelInventoriable(model)) return null

    const available = IsAvailabilityBadgeVisibleService.#availableStockService.availableStock(model, options)

    switch (inventoryStrategy.availabilityBadgeDisplayType) {
      case AVAILABILITY_BADGE_DISPLAY_TYPES.ALWAYS:
        return available !== null
      case AVAILABILITY_BADGE_DISPLAY_TYPES.LOW_STOCK:
        return typeof available === 'string' && +available < inventoryStrategy.availabilityBadgeLowStockThreshold
      case AVAILABILITY_BADGE_DISPLAY_TYPES.OUT_OF_STOCK:
        return IsAvailabilityBadgeVisibleService.#isOutOfStockService.isOutOfStock(model, options)
      default:
        return true
    }
  }
}

const isAvailabilityBadgeVisibleService = new IsAvailabilityBadgeVisibleService({
  availabilitiesAndConstraintsService,
  availableStockService,
  isOutOfStockService
})

export default isAvailabilityBadgeVisibleService
